import { render, staticRenderFns } from "./CommentNode.vue?vue&type=template&id=08df163c&"
import script from "./CommentNode.vue?vue&type=script&lang=js&"
export * from "./CommentNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports